"use client";
import { ark } from "../factory.js";
import { useFieldContext } from "./use-field-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/field/field-label.tsx
var FieldLabel = forwardRef((props, ref) => {
	const mergedProps = mergeProps(useFieldContext()?.getLabelProps(), props);
	return /* @__PURE__ */ jsx(ark.label, {
		...mergedProps,
		ref
	});
});
FieldLabel.displayName = "FieldLabel";
//#endregion
export { FieldLabel };
